import config from '@/core/config/config';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { Button, Dialog, Stack } from '@prenuvo/halo-web';
import { useShallow } from 'zustand/react/shallow';

const LogInDialog = () => {
  const { logInDialog, setLogInDialog } = usePrenuvoStore(
    useShallow((state) => ({
      logInDialog: state.ui.logInDialog,
      setLogInDialog: state.ui.methods.setLogInDialog,
    })),
  );

  return (
    <Dialog
      title={{ children: 'Sign In' }}
      open={logInDialog}
      footer={
        <Stack gap={4} justification="end">
          <Button variant="text" onClick={() => setLogInDialog(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => window.open(`${config.BASE_URL}/login`)}>
            Sign In
          </Button>
        </Stack>
      }
    >
      <p>
        Please log into your account to complete the booking or call us at
        <a href="tel:18337736886"> 1-833-773-6886 </a>for assistance
      </p>
    </Dialog>
  );
};

export default LogInDialog;
